import api from '@/services/utils/apiInstance'

class CollaboratorService {
  async getPaginatedAccountCollaboratorsList(
    search,
    sort,
    order,
    page,
    limit,
    accountId = null,
    signal
  ) {
    let url = ''
    if (accountId) {
      url =
        '/admin/account/' +
        accountId +
        '/collaborators/list?search=' +
        encodeURIComponent(search) +
        '&sort=' +
        sort +
        '&order=' +
        order +
        '&page=' +
        page +
        '&limit=' +
        limit
    } else {
      url =
        '/account/collaborators/list?search=' +
        encodeURIComponent(search) +
        '&sort=' +
        sort +
        '&order=' +
        order +
        '&page=' +
        page +
        '&limit=' +
        limit
    }
    const response = await api.get(url, { signal })
    return response.data
  }

  async getCollaborator(collaboratorId, accountId = null) {
    let url = ''
    if (accountId) {
      url = '/admin/account/' + accountId + '/collaborator/' + collaboratorId
    } else {
      url = '/account/collaborator/' + collaboratorId
    }
    const response = await api.get(url)
    return response.data
  }

  async updateCollaborator(data, accountId = null) {
    let url = ''
    if (accountId) {
      url = '/admin/account/' + accountId + '/collaborator'
    } else {
      url = '/account/collaborator'
    }
    const response = await api.put(url, data)
    return response.data
  }

  async createCollaborator(data, accountId) {
    const response = await api.post('/admin/account/' + accountId + '/collaborator', data)
    return response.data
  }

  async deactivateCollaborator(accountId, collaboratorId) {
    const url = '/admin/account/' + accountId + '/collaborator/deactivate/' + collaboratorId
    const response = await api.patch(url)
    return response.data
  }

  async createLoginCollaborator(data) {
    const response = await api.post('/auth/login/collaborator', data)
    return response.data
  }

  async switchCollaborator(collaboratorId) {
    await api.post('/account/collaborator/switch/' + collaboratorId)
  }
}

export default new CollaboratorService()
